const categories = [
  { value: "GM", label: "GM" },
  { value: "GMK,GM", label: "GMK (GM Kannada Medium)" },
  { value: "GMR,GM", label: "GMR (GM Rural)" },
  { value: "GMK,GMR,GM", label: "GMRK (GM Rural/Kannada Medium)" },
  { value: "1G,GM", label: "1G (Category 1)" },
  { value: "1K,1G,GMK,GM", label: "1K (1 Kannada Medium)" },
  { value: "1R,1G,GMR,GM", label: "1R (1 Rural)" },
  { value: "1R,1K,1G,GMR,GMK,GM", label: "1RK (1 Rural/Kannada Medium)" },
  { value: "2AG,GM", label: "2A General" },
  { value: "2AK,2AG,GMK,GM", label: "2AK (2A Kannada Medium)" },
  { value: "2AR,2AG,GMR,GM", label: "2AR (2A Rural)" },
  { value: "2AR,2AK,2AG,GMK,GMR,GM", label: "2ARK (2A Rural/Kannada Medium)" },
  { value: "2BG,GM", label: "2B General" },
  { value: "2BK,2BG,GMK,GM", label: "2BK (2B Kannada Medium)" },
  { value: "2BR,2BG,GMR,GM", label: "2BR (2B Rural)" },
  { value: "2BK,2BR,2BG,GMK,GMR,GM", label: "2BRK (2B Rural/Kannada Medium)" },
  { value: "3AG,GM", label: "3A General" },
  { value: "3AK,3AG,GMK,GM", label: "3AK (3A Kannada Medium)" },
  { value: "3AR,3AG,GMR,GM", label: "3AR (3A Rural)" },
  { value: "3AK,3AR,3AG,GMK,GMR,GM", label: "3ARK (3A Rural/Kannada Medium)" },
  { value: "3BG,GM", label: "3B General" },
  { value: "3BK,3BG,GMK,GM", label: "3BK (3B Kannada Medium)" },
  { value: "3BR,3BG,GMR,GM", label: "3BR (3B Rural)" },
  { value: "3BK,3BR,3BG,GMK,GMR,GM", label: "3BRK (3B Rural/Kannada Medium)" },
  { value: "SCG,GM", label: "SC General" },
  { value: "SCK,SCG,GMK,GM", label: "SCK (SC Kannada Medium)" },
  { value: "SCR,SCG,GMR,GM", label: "SCR (SC Rural)" },
  { value: "SCK,SCR,SCG,GMK,GMR,GM", label: "SCRK (SC Rural/Kannada Medium)" },
  { value: "STG,GM", label: "ST General" },
  { value: "STK,STG,GMK,GM", label: "STK (ST Kannada Medium)" },
  { value: "STR,STG,GMR,GM", label: "STR (ST Rural)" },
  { value: "STK,STR,STG,GMK,GMR,GM", label: "STRK (ST Rural/Kannada Medium)" }
];

export default categories;